'use client';

import styled from '@emotion/styled';
import { useEffect } from 'react';
import { Container } from '../../../components/layout/Container';
import { H1 } from '../../../components/styled/typography';
import { DEVICE_SCREENS_MAX_STRING } from '../../../lib/consts';
import { BreadCrumbs } from '../../../components/blocks/BreadCrumbs';
import { Page as PageModel } from '../../../models/page';
import { City } from '../../../models';

const PageContent = styled.section`
  font-family: Golos;
  padding-left: 345px;
  padding-right: 345px;
  padding-top: 15px;
  padding-bottom: 15px;
  color: #000000;
  p {
    margin: 1em 0;
  }
  a {
    color: rgba(244, 67, 54, 0.85);
  }
  ol {
    padding-left: 32px;
  }
  ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  @media only screen and (max-width: 1200px) {
    padding-left: 110px;
    padding-right: 110px;
  }
  ${DEVICE_SCREENS_MAX_STRING.md} {
    padding-left: 0;
    padding-right: 0;
  }
`;

type IPageComponentProps = {
  currentCity: City;
  page: PageModel;
};

export function PageComponent({ currentCity, page }: IPageComponentProps) {
  useEffect(() => {
    const regex = /<script.*?src=['"](.*?)['"]/gm;
    const urls: string[] = [];
    if (page.description && page.description.match(regex)) {
      const matches = page.description.match(regex);

      if (matches) {
        // eslint-disable-next-line no-restricted-syntax
        for (const match of matches) {
          const url = match
            .replace(/<script.*?src=['"]/, '')
            .replace(/['"]/gm, '');

          const script = document.createElement('script');
          script.setAttribute('src', url);
          document.head.appendChild(script);
        }
      }
    }
  }, [page.description]);

  return (
    <Container
      css={{
        padding: '15px 14px',
        [DEVICE_SCREENS_MAX_STRING.md]: {
          padding: '15px 16px',
        },
      }}
    >
      <BreadCrumbs currentCity={currentCity} items={[{ title: page.title }]} />
      <H1
        css={{
          fontFamily: 'Montserrat',
          marginTop: 16,
          [DEVICE_SCREENS_MAX_STRING.md]: {
            fontSize: 32,
            padding: 0,
          },
          '@media only screen and (max-width: 575px)': {
            fontSize: 22,
          },
        }}
      >
        {page.title}
      </H1>
      <main>
        <PageContent dangerouslySetInnerHTML={{ __html: page.description }} />
      </main>
    </Container>
  );
}
